import { createEntitySource } from 'serviceWorker/channelServers/entitySource';
import { DEFAULT_API_SYNC_DEBOUNCE_MS } from 'serviceWorker/const/syncTiming';
import * as dbIssueForm from 'serviceWorker/db/issueForm/issueForm';
import * as dbIssueFormService from 'serviceWorker/db/issueForm/issueFormService';
import { debounceNext } from 'serviceWorker/helpers/debounce';
import { issueFormContract } from 'shared/domain/issueForm/issueFormContract';
import { scheduleIssueFormSyncFromApi } from './index';

/** Issue form of the selected project stored in IndexedDB. */
export const issueFormSource = createEntitySource({
  service: dbIssueFormService,
  contract: issueFormContract,
  sync: debounceNext(() => scheduleIssueFormSyncFromApi(), DEFAULT_API_SYNC_DEBOUNCE_MS),
  readAll: dbIssueForm.get,
});
